<div class="boels-vertical-aligner__inner" [ngClass]="innerWidth">
  <ng-content></ng-content>
</div>
